import DisclaimerMessage from 'components/Message/DisclaimerMessage';
import ForceReadPDF from 'components/PDF/ForceReadPDF';
import { DisclaimerType } from 'const';

const BondConnectPDPAContent = ({ renderBottom, onReadCompleted, adjustPdfViewSize }) => {
  return (
    <div>
      <ForceReadPDF
        style={pdfContainerStyled}
        onReadCompleted={onReadCompleted}
        adjustPdfViewSize={adjustPdfViewSize}
        renderBottom={renderBottom}
        detectScrollEndConfig={detectScrollEndConfig}
        avoidTemplate={false}
      >
        <section className="color-blue-strong">
          <DisclaimerMessage code={DisclaimerType.BondConnectPDPA} dangerous />
        </section>
      </ForceReadPDF>
    </div>
  )
}

const pdfContainerStyled = { width: "100%", zIndex: 999, padding: "0px 16px" };
const detectScrollEndConfig = { once: true, enabledDetection: false, offset: 20 };

export default BondConnectPDPAContent;